import cx from 'classnames';

const LargeFormProgressIndicator = ({
  steps,
  currentStepIndex,
  backgroundColor = '#ffffff',
  stepColor = '#e2e8f0', // bg-gray-300
}) => {
  const gap = 8;
  const height = 32;

  return (
    <>
      <style jsx>{`
        ol {
          display: flex;
          flex-grow: 1;
        }

        li {
          display: flex;
          flex-grow: 1;
          justify-content: center;
          align-items: center;

          position: relative;
          box-sizing: border-box;
          background-color: ${stepColor};
          height: ${height}px;
          text-align: center;
          padding: 0 ${height / 2 - gap / 2}px 0 ${height}px;
          position: relative;
          margin-left: ${gap}px;
        }

        li:before {
          content: '';
          position: absolute;
          border: ${height / 2}px solid transparent;
          border-left-color: ${backgroundColor};
          top: 0px;
          right: ${-height - gap}px;
        }

        li:after {
          content: '';
          position: absolute;
          border: ${height / 2}px solid transparent;
          border-left-color: ${stepColor};
          top: 0px;
          right: -${height}px;
        }

        li:first-child {
          padding: 0 ${height / 2 - gap / 2}px 0 ${height / 2 + gap / 2}px;
          margin-left: 0;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }

        li:last-child {
          padding-right: ${height / 2 + gap / 2}px;
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }

        li:last-child:after,
        li:last-child:before {
          border: none;
        }

        li.complete {
          background-color: #2c5282; // bg-blue-800
          color: white;
        }

        li.complete:after {
          border-left-color: #2c5282; // bg-blue-800
        }

        li.current {
          background: #3182ce; // bg-blue-600
          color: white;
        }

        li.current:after {
          border-left-color: #3182ce; // bg-blue-600
        }
      `}</style>
      <ol className="overflow-hidden select-none text-gray-800">
        {steps.map((label, i) => (
          <li
            key={i}
            className={cx(
              'text-xs md:text-sm',
              i === currentStepIndex && 'current',
              i < currentStepIndex && 'complete',
            )}
            style={{ zIndex: steps.length - i }}
          >
            {label}
          </li>
        ))}
      </ol>
    </>
  );
};

const SmallFormProgressIndicator = (props) => {
  return (
    <div className="w-full h-full">
      <div className="text-xs font-bold text-blue-600 uppercase mb-1">
        Step {props.currentStepIndex + 1} / {props.steps.length}
      </div>
      <div className="bg-gray-300 h-3 w-full rounded">
        <div
          className="bg-blue-600 h-full rounded"
          style={{
            width: `${Math.ceil(
              ((props.currentStepIndex + 1) / props.steps.length) * 100,
            )}%`,
          }}
        />
      </div>
    </div>
  );
};

export const FormProgressIndicator = (props) => {
  return (
    <>
      <div className="flex md:hidden">
        <SmallFormProgressIndicator
          steps={props.steps}
          currentStepIndex={props.currentStepIndex}
        />
      </div>
      <div className="hidden md:flex">
        <LargeFormProgressIndicator
          steps={props.steps}
          currentStepIndex={props.currentStepIndex}
        />
      </div>
    </>
  );
};
